import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { UserRoleDto } from '../../../../codegen/Swagger';
import api from '../../../../libs/api';
import { RootState } from '../../../core/store';
import { ApiCallState, AsyncActionStatus, getApiCallInitialState } from '../../../core/types/store';

export interface SecurityToetsing {
    security: ApiCallState<UserRoleDto[]>;
    isLoaded: boolean;
    methods: string[] | undefined,
}


const initialState: SecurityToetsing = {
    security: getApiCallInitialState(),
    isLoaded: false,
    methods: [],

};

// Thunks
const loadSecurity = createAsyncThunk(`product-reservation-security/security/load-security`, async (moduleName: string, thunkApi) => {
    const data: UserRoleDto[] | null = await api.get('/api/v2/security/Security/Get', {
        safe: true,
        params: { moduleName },
    });
    return data;
});


const productReservationSecuritySlice = createSlice({
    name: 'product-reservation-security/security',
    initialState,
    reducers: {
        setMethods(state) {
            state.isLoaded = true;
            const security = state.security.info;
            security.forEach((securityEntry) => {
                const methods = securityEntry.module?.methods?.map((method) => method.code!);
                for (let index = 0; index < methods!.length; index++) {
                    state.methods?.push(methods![index]);
                }
            });

        },
    },
    extraReducers: (builder) => {
        // get security data
        builder.addCase(loadSecurity.pending, (state) => {
            state.security.status = AsyncActionStatus.loading;
        });
        builder.addCase(loadSecurity.fulfilled, (state, action) => {
            state.security.status = AsyncActionStatus.succeeded;
            state.security.info = action.payload as any;
        });
        builder.addCase(loadSecurity.rejected, (state, action) => {
            state.security.status = AsyncActionStatus.failed;
            state.security.error = action.error.message || '';
            state.security.info = [] as any;
        });
    },
});

const getSecurityRoot = (state: RootState) => state.productReservation.security;

const getSecurity = createSelector(getSecurityRoot, (data) => data.security);
const getMethods = createSelector(getSecurityRoot, (data) => data.methods);
const getIsLoaded = createSelector(getSecurityRoot, (data) => data.isLoaded);

export const productReservationSecurityReducer = productReservationSecuritySlice.reducer;

export const actionsSecurity = { ...productReservationSecuritySlice.actions, loadSecurity };
export const selectors = { getSecurity, getMethods, getIsLoaded };
